import cn from 'classnames';

import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

interface StatsItemProps {
  title: string;
  description: string;
}

export const StatsItem = ({ title, description }: StatsItemProps) => {
  const isMobile = useIsMobile();

  return (
    <Space direction="vertical" size={4} align="center">
      <Heading level={isMobile ? 3 : 2}>{title}</Heading>
      <Text
        size={isMobile ? 14 : 20}
        className={cn('h-color-D60 whitespace-pre-line h-text-center', isMobile && 'h-lh-16')}
      >
        {description}
      </Text>
    </Space>
  );
};
